import {
  GET_STORES,
  GET_STORES_SUCCESS,
  GET_STORES_FAILURE
} from "../constants/storeActionsType";

const initialState = {
  stores: [],
  selectedStore: {},
  isLoading: true,
  error: ""
};

export const storeReducer = (state = initialState, { data, error, type }) => {
  switch (type) {
    case GET_STORES:
      return {
        ...state,
        isLoading: true
      };

    case GET_STORES_SUCCESS:
      return {
        ...state,
        stores: data,
        isLoading: false,
        error: initialState.error
      };

    case GET_STORES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };

    default:
      return state;
  }
};
